<style scoped lang="scss">
  nav {
    box-shadow: 0 0 2px;

    &.navbar {
      padding: 0 1rem;
    }

    a.navbar-brand, a.nav-link {
      display: inline-block;
      padding: .5rem 1rem;
      position: relative;
    }

    sup {
      font-size: 8pt;
      top: -.75em;
    }

    .user-info {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: -.5rem -1rem;
      min-width: 160px;
      padding: .75em .5em;

      &:hover, &[data-active="1"] {
        background-color: #ddd;

        .avatar {
          background-color: #efefef;
        }
      }

      .avatar {
        align-items: center;
        background-color: #ddd;
        border-radius: 100%;
        display: flex;
        flex-direction: row;
        height: 35px;
        justify-content: center;
        margin: 0 .5em 0 0;
        width: 35px;
      }
    }

    .dropdown-menu {
      background-color: #f8f9fa;
      border-radius: 0 0 6px 6px;
      display: none;
      left: 0;
      padding: 0;
      position: absolute;
      top: 57px;
      width: 100%;

      &[data-active="1"] {
        display: block;
      }

      .menu-item {
        display: block;
        color: #22222299;
        padding: .5em;

        &:hover {
          background-color: #efefef;
          text-decoration: none;
        }
      }
    }
  }

  .separator {
    margin: 0 0 5em;
  }
</style>

<template>
  <div>
    <nav class="navbar fixed-top navbar-light bg-light">
      <div class="collapse navbar-collapse container" id="navbar-top">
        <router-link to="/assignments" class="navbar-brand">
          Teary
          <sup>beta</sup>
        </router-link>
        <ul class="navbar-nav my-auto my-2 my-lg-0">
          <li v-if="user.name" class="nav-item">
            <a class="nav-link" href="javascript:;" v-on:click="toggleDropdownMenu">
              <div class="user-info" ref="userInfo" :data-active="isUserInfoActive">
                <div class="avatar">
                  <span>{{ user.email[0] }}</span>
                </div>
                {{ user.email.split('@')[0] }}
              </div>
              <div class="dropdown-menu" ref="dropdownMenu" :data-active="isDropdownMenuActive">
                <router-link to="/logout" class="menu-item">Logout</router-link>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="separator" />
  </div>
</template>

<script>
export default {
  name: 'navbar',
  data: () => ({
    isDropdownMenuActive: false,
    isUserInfoActive: false,
    user: {},
  }),
  methods: {
    async updateUser(user) {
      this.user = user;

      await this.$nextTick;
    },
    toggleDropdownMenu() {
      // eslint-disable-next-line no-bitwise
      this.isDropdownMenuActive ^= true;
      // eslint-disable-next-line no-bitwise
      this.isUserInfoActive ^= true;

      // console.log(this.$refs.dropdownMenu.style.width);
      // this.$refs.dropdownMenu.style.width = `${this.$refs.userInfo.offsetWidth}px`;
      // console.log(this.$refs.dropdownMenu.style.width);
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        const user = await this.$cookies.get('user');
        await this.updateUser(user);
      },
    },
  },
};
</script>
